module.exports = __webpack_public_path__ + "img/corel.3af52a10.png";